import { editStorageObject } from "../../../../../app/state/storageObjectSlice/actions/actions";
import { RootState } from "../../../types";
import { ServiceHandler } from "./storageHandlers";
import { fetchAllStorageObjectVersions } from "../../../../../app/state/storageObjectSlice/actions/versioning-actions";
import { setSelectedObjectId } from "../../../../../app/state/storageObjectSlice/slice";
import { deleteStorageObjectVersion } from "../../../../api/instances/storageApi/versioningMethods";
import { StorageObjectVersion } from "../../../../api/instances/storageApi/types/object_types";
import { StorageObjectValue } from "../../../../api/instances/storageApi/types/service_types";
import {
  clearEditorState,
  clearMessagesAction,
  setSpaValue,
} from "../../../../../features/Editor/redux/slice";
import {
  INITIAL_DOCTYPE,
  INITIAL_EDITOR_VALUE,
} from "../../../../../features/Editor/constants";
import { EditorValue } from "../../../../api/instances/editorApi/types";
import i18n from "../../../../i18n";
import { getEditorMessagesAction } from "../../../../../features/Editor/redux/actions";
import { deleteThreadWithProxy } from "../../../../api/instances/responseApi/api";

export const SpaService: ServiceHandler = {
  async onCreate(listenerApi, normalized, meta) {
    if (normalized.value === null) {
      return;
    }
    try {
      const initialValue: EditorValue = {
        spa_object: {
          ...INITIAL_EDITOR_VALUE,
          html_content: INITIAL_DOCTYPE.replace(
            "{{HEADING}}",
            i18n.t("editor.initial_html_h1"),
          ).replace("{{SUBHEADING}}", i18n.t("editor.initial_html_h2")),
          thread_id: "",
        },
      };
      listenerApi.dispatch(clearMessagesAction());
      await listenerApi.dispatch(
        editStorageObject({
          id: normalized.id,
          name: normalized.friendly_name,
          value: initialValue,
          service: "ai_agents_spa",
          skipUpdateListener: true,
        }),
      );
      listenerApi.dispatch(
        setSelectedObjectId({
          id: normalized.id,
          service: "ai_agents_spa",
          skipSelectHandler: true,
        }),
      );
      listenerApi.dispatch(setSpaValue(initialValue));
    } catch (e) {
      console.error("Ошибка при создании ассистента", e);
    }
  },
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    const spaValue = value as EditorValue;
    const { thread_id } = spaValue.spa_object;
    try {
      listenerApi.dispatch(setSpaValue(spaValue));
      listenerApi.dispatch(
        fetchAllStorageObjectVersions({ service: "ai_agents_spa" }),
      );
      listenerApi.dispatch(clearMessagesAction());
      if (thread_id) {
        listenerApi.dispatch(getEditorMessagesAction(thread_id));
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  async onDelete(listenerApi, id, value) {
    if (id === null || value === null) return;
    const spaValue = value as EditorValue;
    try {
      const { versions, selectedId } = (listenerApi.getState() as RootState)
        .storageObjectState.ai_agents_spa;
      if (versions && selectedId) {
        const currentVersions = versions[selectedId];
        await Promise.all(
          currentVersions.map(
            (version: StorageObjectVersion<StorageObjectValue>) =>
              deleteStorageObjectVersion(
                selectedId as string,
                version?.version_id as string,
                "ai_agents_spa",
              ),
          ),
        );
      }
      if (spaValue?.spa_object?.thread_id) {
        deleteThreadWithProxy(spaValue?.spa_object?.thread_id);
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  async onLeave(listenerApi) {
    listenerApi.dispatch(clearEditorState());
  },
};
